import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import './plugins/element.js'
import './plugins/Vant2.js'
import '@/assets/reset.css'
import '@/assets/global.css'

import i18n from './i18n'

Vue.config.productionTip = false

const errorHandler = (error, vm) => {
  // const title = vm.$t('global.ERROR')
  // vm.$message({
  //   type: 'error',
  //   message: error.message
  // })
  // console.error(error.message)
}
Vue.config.errorHandler = errorHandler
Vue.prototype.$throw = (error, vm) => errorHandler(error, vm)



new Vue({
  router,
  store,
  i18n,
  data: function () {
    return {
      DOMAINNAME: '',
      VISIBLE: false,
      HEADLOGO: false,
      ismobile: window.innerWidth < 768,
      COZEID: '',
    }
  },
  render: h => h(App)
}).$mount('#app')
